export const DEFAULT_TIMEOUT = 1000 * 100
